<script setup lang="ts">
import type { Review } from "@/schemas/review";

defineProps<{ reviews: Review[] }>();
</script>

<template>
  <div class="divide-y-2 divide-light border-y-2 border-light">
    <div v-for="(review, i) in reviews" :key="i" class="flex flex-col gap-8 py-8 lg:flex-row">
      <div class="flex shrink-0 flex-col gap-1  lg:flex-[0_0_25%]">
        <div class="text-xl font-semibold leading-none text-primary">
          {{ review.author }}
        </div>
        <div class="text-lg text-muted">
          {{ review.date }}
        </div>
        <UiRating :rating="review.rating" />
      </div>
      <div class="prose flex-1" v-html="review.content" />
    </div>
  </div>
</template>
